import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { DataInContext } from '../../context/DataInContext';
// import FormDatIn from '../../components/FormDatIN/FormDatIn'
import './DatIN.scss'
import { jwtDecode } from "jwt-decode"
import { Oval } from 'react-loader-spinner'
import { Modal } from 'react-bootstrap';
import IllustrationAccess from "../../assets/img/access.png"
import ModalNewInd from '../../components/Modales/ModalNewInd';
import ModalShowIndicadores from '../../components/Modales/ModalShowIndicadores'
import ModalEditIndicador from '../../components/Modales/ModalEditIndicador';
import ModalEtiqueta from '../../components/Modales/DateIn/ModalEtiqueta';

import { usePlanes } from '../../context/PlanesContext';

function DatIN() {
  const { empresa, fetchEmpresa, fetchEmpresaSinConsultora, area, fetchArea } = usePlanes()
  const { idConsult, id, idArea } = useParams()

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [indicadores, setIndicadores] = useState([])

  const [modalNewInd, setModalNewInd] = useState(false)
  // const [addIndicador, setAddIndicador] = useState(false)
  const [modalIndicador, setModalIndicador] = useState(false)
  const [arrTresMetricas, setArrTresMetricas] = useState([])
  const [errorMetricas, setErrorMetricas] = useState(null)
  
  const [indicadorID, setIndicadorID] = useState({})
  const [editIndicador, setEditIndicador] = useState(null)
  const [areaSelec, setAreaSelec] = useState(null)
  const [etiquetasModal, setEtiquetasModal] = useState([])
  
  const [ModalEditInd, setModalEditInd] = useState(false)
  const [modalDeleteIndicador, setModalDeleteIndicador] = useState(false)
  const [errorDel, setErrorDel] = useState(null)

  const [idIndicador, setIdIndicador] = useState(null)

  const [loadingEtiq, setLoadingEtiq] = useState(true)
  const [errorEtiq, setErrorEtiq] = useState(null)
  const [etiquetas, setEtiquetas] = useState([])
  const [modalEtiqueta, setModalEtiqueta] = useState(false)

  const [etiquetasSeleccionadas, setEtiquetasSeleccionadas] = useState([]);
  const [idEtiq, setIdEtiq] = useState(null)
  const [indicadoresFiltrados, setIndicadoresFiltrados] = useState([])
  const [filtroAplicado, setFiltroAplicado] = useState(false)

  const auth = localStorage.getItem("token")
  const jwtParse = jwtDecode(auth)
  const USER = jwtParse.apirest.objeto

  useEffect(() => {
    const obtenerEtiquetas = () => {
      fetchEtiquetas()
      .then(res => {
        if(res.status !== 0){
          setLoadingEtiq(false)
          setErrorEtiq(res.codeError)
        } else {
          setLoadingEtiq(false)
          setEtiquetas(res.objeto)
        }
      })
    };

    obtenerEtiquetas();

    const firstFetch = () => {
      fetchIndicadores()
      .then(res => {
        if(res !== undefined){
          const errorCode = res.error ?? res.status;
          if(errorCode !== 0){
            setLoading(false)
            setError(res.errorDetalle || res.codeError)
          } else {
            setLoading(false)
            setIndicadores(res.objeto)
          }
        }
      })
    }
    firstFetch()

    if (USER.puesto < 3) {
      if(parseInt(idConsult) === 0){
        fetchEmpresaSinConsultora(USER, id)
      } else {
          fetchEmpresa(USER, idConsult, id)
      }
    }
 
    fetchArea(USER, id, idArea)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[idArea])

  const fetchEtiquetas = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/etiquetas/viewEtiqueta`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
          user: USER,
          idArea: parseInt(idArea),
        })
      })
      const data = await res.json()
      return data
    } catch (error) {
      console.error("Error: Conexión con backend.")
    }
  }

  const fetchIndicadores = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
          user: USER,
          opcion: 1,
          idVista: parseInt(idArea),
        })
      })
      return await res.json()
    } catch (err) {
      setLoading(false)
      setError("Error: Conexión con backend.")
      return { error: 1, errorDetalle: "Error de red", err };
    }
  }

  const handleNewIndicador = () => {
    setModalNewInd(true)
  }

  const handleShowIndicador = async (id) => {
    try {
      setModalIndicador(true)
      const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn/ultimas3Metricas`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
          user: USER,
          fkIndicador: id
        })
      })
      const data = await res.json()
      const errorCode = data.error ?? data.status;
      if(errorCode !== 0){
        setErrorMetricas(data.errorDetalle || data.codeError)
      } else {
        const arr = data.objeto
        const opciones = { timeZone: "America/Argentina/Buenos_Aires", hour12: false, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" };
        const newArr = arr.map((e) => {
          return {
            ...e,
            fecha_metrica: new Intl.DateTimeFormat("es-AR", opciones).format(new Date(e.fecha_metrica)) 
          }
        })
        setArrTresMetricas(newArr)
        const obj = indicadores.find(e => e.id_indicador === id)
        setIndicadorID(obj)
        setAreaSelec(obj.Areas[0].nombre)
        setEtiquetasModal(obj.Etiquetas)
      }
    } catch (error) {
      setErrorMetricas("Error: Conexión con backend.")
    }
  }

  const handleEditIndicador = (id) => {
    const obj = indicadores.find(e => e.id_indicador === id)
    setEditIndicador(JSON.stringify(obj))
    setModalEditInd(true)
  }

  // ELIMINAR INDICADOR
  const showModalDeleteIndicador = (id) => {
    setIdIndicador(id)
    setModalDeleteIndicador(true)
    setErrorDel(null)
  }

  const handleDeleteIndicador = async () => {
    const obj = {
      user: USER,
      idIndicador: parseInt(idIndicador)
    }
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn/deleteIndicador`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(obj)
      })
      const data = await res.json()
      const errorCode = data.error ?? data.status;
      if(errorCode !== 0){
        setErrorDel(data.errorDetalle || data.codeError)
      } else {
        setModalDeleteIndicador(false)
        setLoading(true)
        fetchIndicadores()
        .then(res => {
          const errorCode = res.error ?? res.status;
          if(errorCode !== 0){
            setLoading(false)
            setError(res.errorDetalle || res.codeError)
          } else {
            setLoading(false)
            setIndicadores(res.objeto)
          }
        })
      }
    } catch (error) {
      setErrorDel("Error: Conexión con backend.")
    } 
  }

  const handleModalEtiq = () => {
    setModalEtiqueta(true)
  }

  const handleFilterEtiq = (id) => {
    setFiltroAplicado(true)
    setIdEtiq(id)
    const arr = indicadores.filter(e =>
      e.Etiquetas.some(etiqueta => etiqueta.id_etiqueta === id)
    );
    setIndicadoresFiltrados(arr)
  }

  const eliminarFiltro = () => {
    setFiltroAplicado(false)
    setIdEtiq(null)
    setIndicadoresFiltrados([])
  }

  const asignarEtiquetas = (array, id) => {
    if (!array.length) return Promise.resolve();

    const promesas = array.map((e) => {
      const obj = {
        user: USER,
        opcion: 1,
        idEtiqueta: e.id_etiqueta,
        idIndicador: id,
      }
      return fetch(`${process.env.REACT_APP_API_URL}/apis/etiquetas/asignateEtiqueta`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(obj)
      }).then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json()
      })
    });

    return Promise.all(promesas)
  };

  const desasignarEtiquetas = (array, user) => {
    if (!array.length) return Promise.resolve();
    const promesas = array.map((e) => {
      const obj = {
        user,
        opcion: 1,
        idIndicador: e.Etiquetas_Indicador.fk_indicador,
        idEtiquetaAsignada: e.Etiquetas_Indicador.fk_etiqueta,
      }
      return fetch(`${process.env.REACT_APP_API_URL}/apis/etiquetas/deleteAsignateEtiqueta`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(obj)
      }).then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json()
      })
    });

    return Promise.all(promesas)
  }

  const ruta = USER.puesto >= 3 ? "" : `/consultora/${idConsult}/empresa/${id}`

  return (
    <>
      <DataInContext.Provider value={{ USER, idArea, arrTresMetricas, setArrTresMetricas, indicadorID, setIndicadorID, areaSelec, etiquetasModal, editIndicador, setEditIndicador, handleShowIndicador, setLoading, fetchIndicadores, setError, setIndicadores, errorMetricas, setErrorMetricas, fetchEtiquetas, setLoadingEtiq, setErrorEtiq, etiquetas, setEtiquetas, asignarEtiquetas, etiquetasSeleccionadas, setEtiquetasSeleccionadas, desasignarEtiquetas }}>
        <ModalNewInd show={modalNewInd} onHide={()=>setModalNewInd(false)} animation={false} dialogClassName="custom-fade-modal" />
        <ModalShowIndicadores show={modalIndicador} onHide={()=>setModalIndicador(false)} animation={false} dialogClassName="custom-fade-modal" />
        <ModalEditIndicador show={ModalEditInd} onHide={()=>setModalEditInd(false)} animation={false} dialogClassName="custom-fade-modal" />
        <ModalEtiqueta show={modalEtiqueta} onHide={()=>setModalEtiqueta(false)} animation={false} dialogClassName="custom-fade-modal" />
      </DataInContext.Provider>
      {/* Modal Eliminar Indicador */}
      <Modal className='modal__delete__proyecto' show={modalDeleteIndicador} onHide={() => setModalDeleteIndicador(false)} backdrop="static" centered animation={false} >
        <Modal.Header closeButton>
          <Modal.Title><h3>Eliminar indicador</h3></Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Está seguro de eliminar este indicador?</Modal.Body>
        <Modal.Footer className='d-flex flex-column'>
          <div className='d-flex flex-row align-items-center align-self-end'>
            <button className='btn btn-secondary rounded-pill me-2' onClick={() => setModalDeleteIndicador(false)}>Cancelar</button>
            <button className='btn btn-danger rounded-pill' onClick={handleDeleteIndicador}>Borrar</button>
          </div>
          {errorDel && <span className='msj--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errorDel}</span>}
        </Modal.Footer>
      </Modal>
      {/* Fin Modal Eliminar Indicador */}
      <div className='datin section'>
        <div className='section__header d-flex flex-column flex-md-row justify-content-between align-items-start mb-4'>
          <div className='d-flex flex-row align-items-end mb-2 mb-md-0'>
            <i className='bi bi-bar-chart-fill me-2'></i>
            <h4 className='m-0'><Link to={'/dat-in'} className='breadcrumb__generico'>DatIN</Link> {USER.puesto < 3 && <><i className="bi bi-chevron-right"></i> <Link className='breadcrumb__generico' to={`/dat-in${ruta}`}>{`${empresa}`}</Link></>} <i className="bi bi-chevron-right"></i> {area}</h4>
          </div>
          <button onClick={handleModalEtiq} className='btn btn-sm btn-outline-primary rounded-pill shadow-sm fw-medium px-3'>+ Agregar etiqueta</button>
        </div>
        {/* ETIQUETAS */}
        {loadingEtiq ? (
          <p>Loading...</p>
        ) : (
          <>
            {errorEtiq ? (
              <p>{errorEtiq}</p>
            ) : (
              <>
                {etiquetas.length === 0 ? (
                  <div className='listaEtiquetas--empty d-flex flex-row gap-2 align-items-center mb-3'>
                    <p className='m-0 p-0 fw-medium text-blue-500 text-nowrap'>Filtrar por:</p>
                    <button className='btn btn-sm btn-primary rounded-pill'>Todos</button>
                  </div>
                ) : (
                  <div className='listaEtiquetas d-flex flex-row gap-2 align-items-center mb-3'>
                    <p className='m-0 p-0 fw-medium text-blue-500 text-nowrap'>Filtrar por:</p>
                    <button onClick={eliminarFiltro} className={`btn btn-sm rounded-pill px-3 ${idEtiq ? "btn-outline-secondary" : "btn-primary"}`}>Todos</button>
                    {etiquetas.map((e,i)=>{
                      return <button onClick={()=>handleFilterEtiq(e.id_etiqueta)} key={i} className={`btn btn-sm rounded-pill px-3 ${idEtiq === e.id_etiqueta ? "btn-primary" : "btn-outline-secondary"}`}>{e.nombre_etiqueta}</button>
                    })}
                  </div>
                )}
              </>
            )}
          </>
        )}
        {loading ? (
          <div className='loading__datin d-flex flex-column align-items-center justify-content-center'>
            <Oval
                visible={true}
                height="80"
                width="80"
                color="#0d6efd"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
            />
            <p className='fw-medium'>Loading...</p>
        </div>
        ) : (
          <>
            {error ? (
              <div className='datin__error d-flex flex-column align-items-center justify-content-center'>
                <img className='mb-4' src={IllustrationAccess} alt="" />
                <h2>Oops!</h2>
                <p>{error}</p>
              </div>
            ) : (
              <>
                {indicadores.length === 0 ? (
                  <div className='datin--empty__main d-flex flex-column align-items-center justify-content-center rounded-3 p-4'>
                    <h2 className='fw-semibold mb-1 text-center'>No tienes Indicadores para mostrar aún.</h2>
                    <p className='mb-3 text-center'>Para comenzar, ingresa tu primer indicador:</p>
                    <button className='btn__addIndicador btn btn-primary rounded-pill shadow-sm fw-medium' 
                      onClick={handleNewIndicador}>
                        Agregar indicador
                    </button>
                  </div>
                ) : (
                  <div className='datin__main scroll--y'>
                    {filtroAplicado && indicadoresFiltrados.length === 0 ? (
                      <div className='datinFiltrado--empty d-flex flex-column align-items-center justify-content-center rounded-3 p-4'>
                        <img className='mb-4' src={IllustrationAccess} alt="" />
                        <h2 className='text-blue-500 fw-semibold mb-1 text-center'>Oops!</h2>
                        <p className='mb-3 text-center'>No hay indicadores asignados a esta etiqueta.</p>
                      </div>
                    ) : (
                      (filtroAplicado ? indicadoresFiltrados : indicadores).map((e,i) => {
                      return <div key={i} className='datin__main__container'>
                          <div onClick={()=>handleShowIndicador(e.id_indicador)} className='datin__main__indicador d-flex flex-column justify-content-between shadow-sm rounded-3 border border-light-subtle'>
                            <div className='p-3'>
                              <p className='mb-1'>{e.Areas[0].nombre}</p>
                              <h4 style={{color:e.color[0]}} className='mb-0'>{e.nombre_indicador}</h4>
                            </div>
                            <div style={{backgroundColor:e.color[0]}} className='datin__main__indicador__fecha px-3 py-2 d-flex flex-row rounded-bottom-3 align-items-center justify-content-between'>
                              <p className='text-white mb-0'>{e.Empleados[0].nombre}</p>
                              <div className='d-flex flex-row text-white align-items-center'>
                                <i className="bi bi-calendar-event me-1"></i>
                                <p className='mb-0'>{e.fecha_del_recodatorio.replace(/-/g, '/').split("/").reverse().join("/")}</p>
                              </div>
                            </div>
                          </div>
                          <div className='datin__main__container__buttons p-3 active'>
                              <button onClick={()=>handleEditIndicador(e.id_indicador)} className='btn__edit btn bg-success rounded-circle mb-2 text-white' ><i className="bi bi-pencil"></i></button>
                              <button onClick={()=>showModalDeleteIndicador(e.id_indicador)} className='btn__delete btn bg-danger rounded-circle text-white' ><i className="bi bi-trash3"></i></button>
                            </div>
                        </div>
                      })
                    )}
                    
                    <button className='btn__addIndicador btn btn-primary rounded-pill shadow-sm fw-medium' 
                      onClick={handleNewIndicador}>
                        Agregar indicador
                    </button>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  )
}

export default DatIN